/**
 * Adds characters left counter for passed in inputs. Needs parent form element to search for elements the counters relate to.
 *
 * @example:
 <textarea name="foo" rows="5" class="form-control textarea" maxlength="50"></textarea>
 <span class="counter-chars js-counter-chars" data-bind="foo"></span>

 <script>
 App.views.shared.input_chars_counter($('form').find('.js-counter-chars'));
 </script>
 */
App.namespace.wrap('views.shared.input_chars_counter', ($lengthContainers) => {
  $lengthContainers.each(function () {
    const $lengthContainer = $(this);
    const inputSelector = `[name="${$lengthContainer.attr('data-bind')}"]`;
    const $input = $lengthContainer.parents('form').find(inputSelector);
    const minLength = $lengthContainer.data('min');
    const maxLength = $lengthContainer.data('max');
    const content = $lengthContainer.data('content');

    const render = () => {
      const count = $input.val().replaceAll('\r\n', '\n').length;

      if (content) {
        $lengthContainer.text(
          content
            .replace('{count}', count)
            .replace('{minLength}', minLength)
            .replace('{maxLength}', maxLength),
        );
        return;
      }

      let msg = `${count} characters`;

      if (minLength) {
        msg += `, min ${minLength}`;
      }

      if (maxLength) {
        msg += `, max ${maxLength}`;
      }

      $lengthContainer.text(msg);
    };

    $input.on('input', render);

    render();
  });
});
